class ShopifyCDNHelper {
    static BASE_CDN_URL = "https://cdn.shopify.com/s/files/1/0729/5909/9129/files";
  
    static getBaseCDNUrl() {
      return this.BASE_CDN_URL;
    }
  
    static getFileNameFromShopifyPath(path) {
      if (!path) return '';
      return path.replace(/^files\//, '');
    }
  
    static getCDNUrl(path, queryParams = '') {
      if (!path) return '';
      const fileName = this.getFileNameFromShopifyPath(path);
      return `${this.BASE_CDN_URL}/${fileName}${queryParams}`;
    }
}
window.ShopifyCDNHelper = ShopifyCDNHelper;